import React, { ChangeEvent, ReactNode } from 'react';
import { Switch } from 'evergreen-ui';
import { SettingRow } from './SettingRow';
import styles from '../TargetGroupSettings.module.css';

interface SwitchRowProps {
    label: ReactNode;
    description?: ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

/**
 * Specialised row that renders a Switch on the right side. The public API
 * accepts a simple `(checked: boolean) => void` callback so callers don't
 * have to deal with React change events. Internally we still pass an
 * event-based handler to evergreen-ui's Switch.
 */
export const SwitchRow = ({
    label,
    description,
    checked,
    onChange,
    disabled,
}: SwitchRowProps) => (
    <SettingRow label={label} description={description}>
        <Switch
            height={24}
            checked={checked}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                onChange(event.target.checked)
            }
            disabled={disabled}
            className={styles.switch}
        />
    </SettingRow>
);

export default SwitchRow;
